import css from '../Approvals/css/view-modal.module.css';
import styled from '@emotion/styled';
import {NextOfKinDetails} from './type';
import styles from './css/styles.module.css';
import { NotAvailable } from './styles';



interface NextOfKinDetailsProps{
    data: NextOfKinDetails;
}

const NextOfKin: React.FC<NextOfKinDetailsProps> = ({ data }) => {
  return (
    <div className={`${css.contentDiv} ${css.nextDiv}`}>
      <p className={css.title}>Next of Kin</p>

      {data?.Id ? (
        <div style={{overflowX: 'auto'}}>
        <table>
            <tr className={styles.tableHead}>
              <th>Full Name</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Relationship</th>
              <th>Address 1</th>
              <th>Address 2</th>
            </tr>
          <tr>
            <td>{data.FullName}</td>
            <td>{data.Email}</td>
            <td>{data.PhoneNumber}</td>
            <td>{data.Relationship}</td>
            <td>{data.Address}</td>
            <td>{data.Address}</td>
          </tr>
        </table>
        </div>
      ) : <NotAvailable>Not Available</NotAvailable> }
    </div>
  );
};

export default NextOfKin;


const EachQualificationContainer = styled.div`
  width:100%;
  display:flex;
  flex-wrap:wrap;
  justify-content: space-between;
  row-gap:20px;
  column-gap:10px;
  & > span{
    width: 100%;

  }
  & > span > span{
      padding:7px 10px;
      background-color:#E0FAEE;
      font-weight: 600;
  }
  & > div{
    width:40%;    
  }
`